"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: property/standard_status.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardStatus = exports.protobufPackage = void 0;
exports.standardStatusFromJSON = standardStatusFromJSON;
exports.standardStatusToJSON = standardStatusToJSON;
/* eslint-disable */
exports.protobufPackage = "property";
/**
 * The status of the listing as it reflects the state of the contract
 * between the listing agent and seller, or an agreement with a buyer
 * (e.g., Active, Active Under Contract, Canceled, Closed, Expired,
 * Pending, Withdrawn).
 *
 * For an detailed explanation of this property, see the RESO Data Dictionary
 * article: "[StandardStatus Field]."
 *
 * [StandardStatus Field]: https://ddwiki.reso.org/display/DDW20/StandardStatus+Field
 */
var StandardStatus;
(function (StandardStatus) {
    /** STANDARD_STATUS_UNSPECIFIED - The status is not specified. */
    StandardStatus[StandardStatus["STANDARD_STATUS_UNSPECIFIED"] = 0] = "STANDARD_STATUS_UNSPECIFIED";
    /**
     * STANDARD_STATUS_ACTIVE - The listing is on market and an offer has not been accepted.
     *
     * For an detailed explanation of this property, see the RESO Data Dictionary
     * article: "[Active (StandardStatus)]."
     *
     * [Active (StandardStatus)]: https://ddwiki.reso.org/pages/viewpage.action?pageId=1139055
     */
    StandardStatus[StandardStatus["STANDARD_STATUS_ACTIVE"] = 1] = "STANDARD_STATUS_ACTIVE";
    /**
     * STANDARD_STATUS_ACTIVE_UNDER_CONTRACT - An offer has been accepted but the listing is still on market.
     *
     * For an detailed explanation of this property, see the RESO Data Dictionary
     * article: "[Active Under Contract (StandardStatus)]."
     *
     * [Active Under Contract (StandardStatus)]: https://ddwiki.reso.org/pages/viewpage.action?pageId=1139061
     */
    StandardStatus[StandardStatus["STANDARD_STATUS_ACTIVE_UNDER_CONTRACT"] = 2] = "STANDARD_STATUS_ACTIVE_UNDER_CONTRACT";
    /**
     * STANDARD_STATUS_CANCELED - The listing contract has been terminated.
     *
     * For an detailed explanation of this property, see the RESO Data Dictionary
     * article: "[Canceled (StandardStatus)]."
     *
     * [Canceled (StandardStatus)]: https://ddwiki.reso.org/pages/viewpage.action?pageId=1139067
     */
    StandardStatus[StandardStatus["STANDARD_STATUS_CANCELED"] = 3] = "STANDARD_STATUS_CANCELED";
    /**
     * STANDARD_STATUS_CLOSED - The purchase agreement has been fulfilled or the lease agreement has been executed.
     *
     * For an detailed explanation of this property, see the RESO Data Dictionary
     * article: "[Closed (StandardStatus)]."
     *
     * [Closed (StandardStatus)]: https://ddwiki.reso.org/pages/viewpage.action?pageId=1139074
     */
    StandardStatus[StandardStatus["STANDARD_STATUS_CLOSED"] = 4] = "STANDARD_STATUS_CLOSED";
    /**
     * STANDARD_STATUS_COMING_SOON - This is a listing that has not yet been on market but will be on market soon.
     * A listing contract has been executed. Some systems may use Hold or Withdrawn
     * for similar purposes. When all three are in use, Hold expresses a listing
     * that may have been on market but is off market temporarily and is expected
     * to return to market. Withdrawn may have been on market but, when used in
     * conjunction with Hold, is not expected to return to market. Coming Soon
     * is different from Hold and Withdrawn, as the property, under the current
     * listing contract only, has not been previously on market.
     * For an detailed explanation of this property, see the RESO Data Dictionary
     * article: "[Coming Soon (StandardStatus)]."
     *
     * [Coming Soon (StandardStatus)]: https://ddwiki.reso.org/pages/viewpage.action?pageId=1139079
     */
    StandardStatus[StandardStatus["STANDARD_STATUS_COMING_SOON"] = 5] = "STANDARD_STATUS_COMING_SOON";
    /**
     * STANDARD_STATUS_DELETE - The listing contract was never valid or there is another reason for the
     * contract to be nullified.
     *
     * For an detailed explanation of this property, see the RESO Data Dictionary
     * article: "[Delete (StandardStatus)]."
     *
     * [Delete (StandardStatus)]: https://ddwiki.reso.org/pages/viewpage.action?pageId=1139086
     */
    StandardStatus[StandardStatus["STANDARD_STATUS_DELETE"] = 6] = "STANDARD_STATUS_DELETE";
    /**
     * STANDARD_STATUS_EXPIRED - The listing contract has expired.
     *
     * For an detailed explanation of this property, see the RESO Data Dictionary
     * article: "[Expired (StandardStatus)]."
     *
     * [Expired (StandardStatus)]: https://ddwiki.reso.org/pages/viewpage.action?pageId=1139094
     */
    StandardStatus[StandardStatus["STANDARD_STATUS_EXPIRED"] = 7] = "STANDARD_STATUS_EXPIRED";
    /**
     * STANDARD_STATUS_HOLD - A contract exists between the seller and the listing member.
     * The listing may be completely off market, not allowing any showings and/or
     * not taking any further offers. For systems that don't use Hold, Withdrawn
     * is a similar status that may be in use. When both Hold and Withdrawn
     * are in use, Withdrawn may be used to indicate a greater certainty that
     * the listing will not come back on market.
     *
     * For an detailed explanation of this property, see the RESO Data Dictionary
     * article: "[Hold (StandardStatus)]."
     *
     * [Hold (StandardStatus)]: https://ddwiki.reso.org/pages/viewpage.action?pageId=1139099
     */
    StandardStatus[StandardStatus["STANDARD_STATUS_HOLD"] = 8] = "STANDARD_STATUS_HOLD";
    /**
     * STANDARD_STATUS_INCOMPLETE - The listing has not yet been completely entered and is not yet published in the MLS.
     *
     * For an detailed explanation of this property, see the RESO Data Dictionary
     * article: "[Incomplete]."
     *
     * [Incomplete]: https://ddwiki.reso.org/display/DDW20/Incomplete
     */
    StandardStatus[StandardStatus["STANDARD_STATUS_INCOMPLETE"] = 9] = "STANDARD_STATUS_INCOMPLETE";
    /**
     * STANDARD_STATUS_PENDING - An offer has been accepted and the listing is no longer on market.
     *
     * For an detailed explanation of this property, see the RESO Data Dictionary
     * article: "[Pending (StandardStatus)]."
     *
     * [Pending (StandardStatus)]: https://ddwiki.reso.org/pages/viewpage.action?pageId=1139110
     */
    StandardStatus[StandardStatus["STANDARD_STATUS_PENDING"] = 10] = "STANDARD_STATUS_PENDING";
    /**
     * STANDARD_STATUS_WITHDRAWN - The listing has been withdrawn from the market, but a contract still
     * exists between the seller and the listing member. For those systems that
     * use both Hold and Withdrawn, Withdrawn may represent an intention not to
     * bring the listing back on the market. When Hold is not used by the system,
     * Withdrawn does not represent any intention of returning to market or not.
     *
     * For an detailed explanation of this property, see the RESO Data Dictionary
     * article: "[Withdrawn (StandardStatus)]."
     *
     * [Withdrawn (StandardStatus)]: https://ddwiki.reso.org/pages/viewpage.action?pageId=1139116
     */
    StandardStatus[StandardStatus["STANDARD_STATUS_WITHDRAWN"] = 11] = "STANDARD_STATUS_WITHDRAWN";
    StandardStatus[StandardStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StandardStatus || (exports.StandardStatus = StandardStatus = {}));
function standardStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "STANDARD_STATUS_UNSPECIFIED":
            return StandardStatus.STANDARD_STATUS_UNSPECIFIED;
        case 1:
        case "STANDARD_STATUS_ACTIVE":
            return StandardStatus.STANDARD_STATUS_ACTIVE;
        case 2:
        case "STANDARD_STATUS_ACTIVE_UNDER_CONTRACT":
            return StandardStatus.STANDARD_STATUS_ACTIVE_UNDER_CONTRACT;
        case 3:
        case "STANDARD_STATUS_CANCELED":
            return StandardStatus.STANDARD_STATUS_CANCELED;
        case 4:
        case "STANDARD_STATUS_CLOSED":
            return StandardStatus.STANDARD_STATUS_CLOSED;
        case 5:
        case "STANDARD_STATUS_COMING_SOON":
            return StandardStatus.STANDARD_STATUS_COMING_SOON;
        case 6:
        case "STANDARD_STATUS_DELETE":
            return StandardStatus.STANDARD_STATUS_DELETE;
        case 7:
        case "STANDARD_STATUS_EXPIRED":
            return StandardStatus.STANDARD_STATUS_EXPIRED;
        case 8:
        case "STANDARD_STATUS_HOLD":
            return StandardStatus.STANDARD_STATUS_HOLD;
        case 9:
        case "STANDARD_STATUS_INCOMPLETE":
            return StandardStatus.STANDARD_STATUS_INCOMPLETE;
        case 10:
        case "STANDARD_STATUS_PENDING":
            return StandardStatus.STANDARD_STATUS_PENDING;
        case 11:
        case "STANDARD_STATUS_WITHDRAWN":
            return StandardStatus.STANDARD_STATUS_WITHDRAWN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return StandardStatus.UNRECOGNIZED;
    }
}
function standardStatusToJSON(object) {
    switch (object) {
        case StandardStatus.STANDARD_STATUS_UNSPECIFIED:
            return "STANDARD_STATUS_UNSPECIFIED";
        case StandardStatus.STANDARD_STATUS_ACTIVE:
            return "STANDARD_STATUS_ACTIVE";
        case StandardStatus.STANDARD_STATUS_ACTIVE_UNDER_CONTRACT:
            return "STANDARD_STATUS_ACTIVE_UNDER_CONTRACT";
        case StandardStatus.STANDARD_STATUS_CANCELED:
            return "STANDARD_STATUS_CANCELED";
        case StandardStatus.STANDARD_STATUS_CLOSED:
            return "STANDARD_STATUS_CLOSED";
        case StandardStatus.STANDARD_STATUS_COMING_SOON:
            return "STANDARD_STATUS_COMING_SOON";
        case StandardStatus.STANDARD_STATUS_DELETE:
            return "STANDARD_STATUS_DELETE";
        case StandardStatus.STANDARD_STATUS_EXPIRED:
            return "STANDARD_STATUS_EXPIRED";
        case StandardStatus.STANDARD_STATUS_HOLD:
            return "STANDARD_STATUS_HOLD";
        case StandardStatus.STANDARD_STATUS_INCOMPLETE:
            return "STANDARD_STATUS_INCOMPLETE";
        case StandardStatus.STANDARD_STATUS_PENDING:
            return "STANDARD_STATUS_PENDING";
        case StandardStatus.STANDARD_STATUS_WITHDRAWN:
            return "STANDARD_STATUS_WITHDRAWN";
        case StandardStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
//# sourceMappingURL=standard_status.js.map